import { useUser } from 'contexts/UserContext'

/**
 * Hook para controlar qué módulos tiene activos el usuario actual.
 *
 * Módulos posibles:
 *   "chatbot"    — Asistentes, Vector Stores, Chats, Estadísticas
 *   "centralita" — Centralita AI (llamadas Retell)
 *
 * Si el usuario no tiene "modules" definido (legacy/admin), tiene acceso a todo.
 *
 * Uso:
 *   const { hasChatbot, hasCentralita, hasModule } = useModules()
 *   if (!hasCentralita) return null
 */
export default function useModules() {
  const { user } = useUser()

  // El login devuelve modules como array: ["chatbot", "centralita"]
  // Si no existe → acceso completo (compatibilidad con usuarios antiguos)
  const modules = user?.modules ?? ['chatbot', 'centralita']

  const hasModule = (moduleName) => modules.includes(moduleName)

  return {
    modules,
    hasModule,
    hasChatbot:    hasModule('chatbot'),
    hasCentralita: hasModule('centralita'),
    // Conveniencia: tiene al menos uno
    hasAny: modules.length > 0,
  }
}